import React, { FC } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

import Title from './Title'

type ChartData = {
  name: string
  ALL: number
  REVUP: number
  ENGAGED: number
  REENGAGED: number
}

type Props = {
  data: ChartData[]
  title: string
}
const containerProps = {
  minWidth: 200,
  height: 200,
  aspect: 1.5,
}
const EmailOpened: FC<Props> = ({ data, title }) => {
  return (
    <div>
      <Title>{title}</Title>
      <ResponsiveContainer {...containerProps}>
        <BarChart
          width={300}
          height={200}
          data={data}
          margin={{
            top: 5,
            left: -20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="ALL" fill="#CC1010" />
          <Bar dataKey="REVUP" fill="#E349A8" />
          <Bar dataKey="ENGAGED" fill="#09B724" />
          <Bar dataKey="REENGAGED" fill="#2A2AE0" />
        </BarChart>
      </ResponsiveContainer>
      <div className="explanation graph">
        <div className="item">
          <div className="item-square" style={{ background: '#CC1010' }} />
          <p className="item-text">ALL</p>
        </div>
        <div className="item">
          <div className="item-square" style={{ background: '#09B724' }} />
          <p className="item-text">ENGAGED</p>
        </div>
      </div>
      <div className="explanation graph">
        <div className="item">
          <div className="item-square" style={{ background: '#E349A8' }} />
          <p className="item-text">REV-UP</p>
        </div>
        <div className="item">
          <div className="item-square" style={{ background: '#2A2AE0' }} />
          <p className="item-text">RE-ENGAGE</p>
        </div>
      </div>
    </div>
  )
}
export default EmailOpened
